import {
  Button,
  Content,
  InputBox,
  Img,
  FileUploadButton,
  TextAreaBox,
  ContentLayout,
} from "@adminComponents";
import React, {useEffect, useState} from "react";
import styles from "./style.module.scss";
import {adminApi, utils} from "@utils";
import * as Datas from "@adminData";

export default function Page() {
  const [aboutData, setAboutData] = useState<Datas.IInfoResponse>();

  async function getDetail() {
    try {
      const {data, success, message} = await adminApi.info.getDetail({
        type: "about",
      });
      if (success) {
        setAboutData(data.result);
      } else {
        alert(message || "오류가 발생했습니다");
      }
    } catch (error) {
      console.error("getDetail error", error);
    }
  }

  async function save() {
    try {
      const {success, message} = await adminApi.info.save(
        [aboutData].filter(item => !!item),
      );
      return {success, message};
    } catch (error) {
      console.error("saveInfo error", error);
      return {success: false, message: "오류가 발생했습니다."};
    }
  }

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <>
      <ContentLayout
        title="회장인사말"
        rightElement={
          <div className={styles.bottomSection}>
            <Button
              backgroundColor="#d9d9d9"
              fontSize={18}
              paddingHorizontal={39}
              paddingVertical={12}
              text={"저장"}
              onClick={save}
            />
          </div>
        }>
        <Content>
          <div className={styles.content}>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                회장 사진
              </div>
              <div className={styles.col}>
                <div>
                  <FileUploadButton
                    text={"업로드"}
                    height={32}
                    width={32}
                    uploadUrl={"/api/v1/upload/info"}
                    fileUpload={data => {
                      const newFiles: Datas.IFiles[] = (data.files || [])
                        .slice(0, 1)
                        .map((item, index) => ({
                          url: item,
                          thumb_img_url: (data.thumbList || [])[index],
                        }));
                      setAboutData?.(prev => ({
                        ...prev,
                        files: newFiles,
                      }));
                    }}
                  />
                </div>
              </div>
              {(aboutData?.files || []).length > 0 && (
                <div className={styles.imageContainer}>
                  {(aboutData?.files || []).map(
                    ({url, thumb_img_url}, index) => {
                      const imgUrl = thumb_img_url || url;
                      return (
                        <div key={index} className={styles.imageContainer}>
                          <Img src={imgUrl} className={styles.img} />
                          <div className={styles.btnContainer}>
                            {index > 0 && (
                              <div
                                className={styles.item}
                                onClick={() => {
                                  const newFiles = utils.moveArrayValue({
                                    array: aboutData?.files || [],
                                    fromIndex: index,
                                    toIndex: index - 1,
                                  });
                                  setAboutData?.(prev => ({
                                    ...prev,
                                    files: newFiles,
                                  }));
                                }}>
                                🔼
                              </div>
                            )}
                            <div
                              className={styles.item}
                              onClick={() => {
                                if (!confirm("이미지를 삭제하시겠습니까?")) {
                                  return;
                                }
                                setAboutData(prev => ({
                                  ...prev,
                                  files: (prev?.files || []).filter(
                                    (temp, i) => i !== index,
                                  ),
                                }));
                              }}>
                              ❎
                            </div>
                            {index < (aboutData?.files || []).length - 1 && (
                              <div
                                className={styles.item}
                                onClick={() => {
                                  const newImages = utils.moveArrayValue({
                                    array: aboutData?.files || [],
                                    fromIndex: index,
                                    toIndex: index + 1,
                                  });
                                  setAboutData(prev => ({
                                    ...prev,
                                    files: newImages,
                                  }));
                                }}>
                                🔽
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    },
                  )}
                </div>
              )}
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                회장인사말 제목
              </div>
              <div className={styles.col}>
                <TextAreaBox
                  value={aboutData?.title}
                  onValue={value => {
                    setAboutData(prev => ({...prev, title: value}));
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                회장인사말 내용
              </div>
              <div className={styles.col}>
                <TextAreaBox
                  value={aboutData?.content}
                  onValue={value => {
                    setAboutData(prev => ({...prev, content: value}));
                  }}
                  boxStyle={{flex: 1}}
                  height={200}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                회장인사말 이름
              </div>
              <div className={styles.col}>
                <InputBox
                  value={aboutData?.sub_title}
                  onValue={value => {
                    setAboutData(prev => ({...prev, sub_title: value}));
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
          </div>
        </Content>
      </ContentLayout>
    </>
  );
}
